import { InjectionToken } from '@angular/core';

export const VERTICAL_PARENT = new InjectionToken('Parent Component');
